// extracted by mini-css-extract-plugin
var _1 = "Form_form__9aaV7";
export { _1 as "form" }
